import { TRACKING_ACTION, TRACKING_COMPARE, TRACKING_INTERACTION } from 'contexts/AnalyticsContext/Constants';
import { trackEvent } from 'lib/ui-analytics';
import { getItineraryCardInfo } from 'lib/ui-analytics/utils';

export const utagExploreItineraryLinkClicked = (params) => {
    const { cruise, count, index, locale } = params;
    const event = {
        cardPosition: [1],
        country: locale.country,
        currency: locale.currency,
        language: locale.language,
        siteSection: TRACKING_COMPARE.COMPARE_PAGE,
        pageName: TRACKING_COMPARE.COMPARE_PAGE,
        departureDate: [cruise?.lowestPriceSailing?.startDate],
        eventType: TRACKING_ACTION.INTERACTION,
        interaction: formatInteraction(
            TRACKING_INTERACTION.COMPARE.EXPLORE_FULL_ITINERARY, 
            cruise, count, index 
        ),
        itineraryCardInfo: getItineraryCardInfo(cruise?.cruise?.id, cruise?.masterSailing, cruise?.lowestPriceSailing),
        prodCost: [Math.round(cruise?.lowestPriceSailing?.lowestStateroomClassPrice?.price?.value)],
        prodSku: [cruise?.masterSailing?.itinerary?.code],
        productEvent: [TRACKING_COMPARE.EXPLORE_ITINERARY]
    }
    trackEvent(event);
}

export const formatInteraction = (interactionLabel, cruise, count, index) => {
  const cruiseTitle = cruise?.masterSailing?.itinerary?.name ?? '';
  const totalNights = cruise?.masterSailing?.itinerary?.totalNights ?? '';

  if (!cruiseTitle || !totalNights) return '';

  return interactionLabel
    .replace('{0}', index + 1)
    .replace('{1}', count)
    .replace('{numberOfNights}', totalNights)
    .replace('{cruiseTitle}', cruiseTitle)
}